export const LegacyAuth = 'auth';
export const Impersonation = 'x-imp';
export const ImpersonationExpires = 'x-imp-exp';
export const SSHome = 'SSHome';
export const V3Access = 'v3Access';
export const V3Claims = 'v3Claims';
export const InitialLogin = 'initial:login';
export const OnboardReturn = 'onboard-return';
export const Auth0IsAuthenticated = 'auth0.is.authenticated';
export const Auth0IsLogin = 'auth0.is.login';
export const SSASIsAuthenticated = 'ssas.is.authenticated';
// Getter function to avoid accessing window.SS_GLOBALS at module load time (Vite timing issue)
export const getAuth0IsClientAuthenticated = () => `auth0.${window.SS_GLOBALS.frontEndConfig.auth0ClientId}.is.authenticated`;
export const getLegacyAuth0IsClientAuthenticated = () => `_legacy_${getAuth0IsClientAuthenticated()}`; // auth0 adds this automatically for older browsers
export const Auth0PartitionHostChanged = 'auth0.partition.host.changed';
export const AccessTokenV2 = '_lat';
export const AccessTokenV3 = '_latv3';
export const PreferredLocale = 'PreferredLocale';
export const bypassCaptcha = 'bypass_captcha';
export const AuthErrorOrLogoutMsg = 'ss.logout.msg';
export const NeedsLoggedOutForMaintMsg = 'logout.for.maint.msg';
export const ResumeSsrActivationPath = 'returns.ssr.activation.path';
export const PromotionalPlanCookieName = 'promotional_plan';

export const signupEmail = 'signup_email';
export const MarketplaceRedirect = 'marketplace_redirect';
